// @TODO: remove when back-end is ready to send enum instead of String type
export enum Store {
  FR = 'fr',
  US = 'us',
}
